import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addWeeks } from "date-fns";
import { computed } from "vue";
import OrderSumBNPL from "./OrderSumBNPL.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSumBNPLDolyame',
    props: {
        sum: { type: Number, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var payments = computed(function () {
            var payments = [];
            for (var number = 1; number <= 4; number++) {
                payments.push({
                    amount: makeAmount(number),
                    date: addWeeks(new Date(), (number - 1) * 2),
                });
            }
            return payments;
        });
        function makeAmount(number) {
            var partSum = Math.floor(props.sum / 4);
            return number === 4 ? props.sum - partSum * 3 : partSum;
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(OrderSumBNPL, { payments: payments.value }, null, 8 /* PROPS */, ["payments"]));
        };
    }
});
